import React from 'react';
import './Contact.css';
import contactArt from '../media/contact_art.png';

const Contact: React.FC = () => {
  const [name, setName] = React.useState('');
  const [contact, setContact] = React.useState('');
  const [info, setInfo] = React.useState('');

  const mailToAction = `mailto:boogiebrown-dj@outlook.com?subject=Enquiring%20about%20DJing&body=NAME%20'${name}'%20CONTACT%20'${contact}'%20INFO%20'${info}'`;

  return (
    <div className="contact page-container">
      <div className="page-image-column">
        <img src={contactArt} alt="Contact" />
      </div>
      <div className="page-content-column">
        <h2>AVAILABLE FOR</h2>
        <p>PRIVATE EVENTS - CLUBS - CORPORATE - INTERNET</p>

        <h2>SOCIAL</h2>
        <div className="social-links">
          <a href="mailto:boogiebrown-dj@outlook.com">
            <span className="icon">✉</span>boogiebrown-dj@outlook.com
          </a>
          <a href="https://twitter.com/DJ_BoogieBrown" target="_blank" rel="noopener noreferrer">
            <span className="icon">𝕏</span>@dj_boogiebrown
          </a>
          <a href="https://www.instagram.com/dj_boogiebrown/" target="_blank" rel="noopener noreferrer">
            <span className="icon">📷</span>@dj_boogiebrown
          </a>
        </div>

        <h2>CONTACT</h2>
        <p>SEATTLE AREA - 425 894 1604</p>
        <hr />
        <h2>SEND MESSAGE</h2>
        <div className="contact-form">
          <div className="form-group">
            <label>NAME</label>
            <input
              type="text"
              name="contact_name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>PHONE OR EMAIL</label>
            <input
              type="text"
              name="contact_details"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>MESSAGE</label>
            <textarea
              name="contact_info"
              value={info}
              onChange={(e) => setInfo(e.target.value)}
              rows={5}
            ></textarea>
          </div>
          <div className="form-group">
            <a href={mailToAction} className="btn-send">SEND</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
